export default __webpack_public_path__ + "static/media/Logo.f0b667fa.png";